import { createContext, useContext } from 'react'

export const CollapseContext = createContext<{
  currentKey: React.Key | null
  changeKey: (key: React.Key | null) => void
}>({
  currentKey: 0,
  changeKey: () => {},
})

export function useCollapseContext() {
  return useContext(CollapseContext)
}
